module.exports = __webpack_public_path__ + "media/images/team/martha-33116b0079e3eb749d6b87ecb5c57ef2.jpg";